/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MobileCustomizeAccounts.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Store from 'state/Store';

import {
  resetAccountVisibility,
  accountVisibilityUpdated,
  errorUpdateAccountVisibility
} from 'state/preferences/PreferencesActions';
import { getAreAllAccountsHidden } from 'state/preferences/PreferencesSelectors';
import { FormattedDate } from 'components/shared/Text/Text';
import { NON_BREAKING_SPACE } from 'services/Formats';
import { updateCustomerPreferences } from 'services/Rest';
import { constructAccountVisibilityPayload } from 'services/Preferences';
import SaveLoadingButtonWithPermissions from 'components/shared/LoadingButton/SaveLoadingButtonWithPermissions';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import AccountVisibilityTable from './AccountVisibilityTable';
import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import Content from 'services/Content';
import { getReceivedAccounts } from 'state/account/AccountSelectors';

class MobileAccountVisibility extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      changesSaved: false
    };
  }

  componentWillUnmount() {
    const { changesSaved } = this.state;
    if (!changesSaved) {
      Store.dispatch(resetAccountVisibility());
    }
  }

  saveHideShowValues = () => {
    const { accounts, defaultAccounts } = this.props;
    const payload = constructAccountVisibilityPayload(
      accounts,
      defaultAccounts
    );
    const updatedHideShowAccountsPayload = {
      accountVisibility: [...payload]
    };
    updateCustomerPreferences(
      updatedHideShowAccountsPayload,
      Store.dispatch(accountVisibilityUpdated()),
      () => {Store.dispatch(errorUpdateAccountVisibility())}
    );
    this.setState({ changesSaved: true });
  };

  render() {
    const { asOfDate, is529Only, disableSave, allAccountsHidden } = this.props;
    return (
      <Fragment>
        <PreferencesHeader>
          <div className="mobile-customize-accounts-view-header">
            Account Visibility
          </div>
        </PreferencesHeader>
        <PreferencesSection fullBackground={true}>
          <PreferencesRow className="mobile-account-visibility-row">
            <PreferencesCol col={3}>
              <div className="mobile-customize-accounts-table-header-name">
                Name
              </div>
            </PreferencesCol>
            <PreferencesCol col={12}>
              <div className="mobile-customize-accounts-table-header-visibility">
                Visibility
              </div>
            </PreferencesCol>
            <PreferencesCol col={12}>
              <AccountVisibilityTable />
            </PreferencesCol>
          </PreferencesRow>
        </PreferencesSection>
        <div className="mobile-account-visibility-footer">
          <SaveLoadingButtonWithPermissions
            className="customize-accounts-save-button mobile-account-visibility-save-button"
            id="save-account-visibility"
            onClick={this.saveHideShowValues}
            disabled={disableSave || allAccountsHidden}
            requestStatusKey="updateCustomerPreferences"
            shouldDisable>
            Save
          </SaveLoadingButtonWithPermissions>
          {allAccountsHidden && (
            <div className="hidden-disclosure">
              At least one Account must be visible.
            </div>
          )}
          <div>
            <span className="disclaimer-text">
              Balances as of <FormattedDate>{asOfDate}</FormattedDate>
              {NON_BREAKING_SPACE}
              <DisclosureModal
                content={
                  is529Only
                    ? Content.asOfDateDisclosure529Only
                    : Content.asOfDateDisclosure
                }
                title="Important Information Regarding the Updating of Account Balances"
                hideLinkContent
              />
            </span>
          </div>
          <div className="disclaimer-text">
            Accounts will be hidden from the Dashboard, Accounts and Transaction
            flows.
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  asOfDate: state.balances.asOfDate,
  is529Only: state.view.hasCollegeSavingsOnly,
  accounts: state.accounts,
  defaultAccounts: getReceivedAccounts(state),
  disableSave: state.disableAccountVisibilitySave,
  allAccountsHidden: getAreAllAccountsHidden(state)
});

export default connect(mapStateToProps)(MobileAccountVisibility);
